import { DashboardJobsStatus, IDashboardJob } from '~/domain/DashboardJobs';
import history from '../../../../../history';
import { headerOpenTabTitles } from '../../utils';
import { CustomTable } from '../CustomTable';
import { renderRow } from './renderRow';

export const OpenTabLegacy = () => {
  const handleOnClick = (item: IDashboardJob) => {
    history.push(`/dashboard/job/${item.id}`);
  };

  return (
    <CustomTable
      type={DashboardJobsStatus.OPEN}
      renderRow={(item) => renderRow({ item, handleOnClick })}
      headerTitles={headerOpenTabTitles}
      onRowClick={(item) => handleOnClick(item)}
    />
  );
};
